import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Form, } from 'reactstrap';
import { isEmpty, mapValues } from 'lodash';

import useFormState from '../hooks/useFormState';
import Field from '../Field';

const { entries } = Object;
const fields = () => {
  return {
    name: {
      type: 'boolean',
      label: '利用規約およびプライバシーポリシーに同意する',
      validations: {
        required: v => v === true,
      },
    },
  };
};

export default function AcceptionFormModal(props) {
  const { user } = props;
  const statedFields = useFormState({}, fields());
  const isUnsubmittable = Object.values(statedFields).some(_ => !_.isValid);
  const onSubmit = async (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;

    await user.ref.update({ isAccepted: true });
  };

  return (
    <Modal isOpen>
      <ModalHeader>
        利用規約およびプライバシーポリシーへの同意
      </ModalHeader>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <ModalBody>
            <div className="mb-3">
              <a href="https://www.freee.co.jp/terms/" target="_blank">
                利用規約およびプライバシーポリシー
                <span className="fas fa-external-link-alt ml-1" />
              </a>
            </div>
            {
              entries(statedFields).map(([fieldName, fieldSetting]) => (
                <Field
                  key={fieldName}
                  name={fieldName}
                  {...fieldSetting}
                />
              ))
            }
          </ModalBody>
        </ModalBody>
        <ModalFooter>
          <Button className="save" type="submit" color="primary" onClick={onSubmit} disabled={isUnsubmittable}>送信</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};
